const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function email(err) {
    return value => {
        if (!emailRegex.test(value)) {
            return err || true;
        }

        return false;
    }
}

function equals(err, compareValue = '') {
    return value => {
        console.log('comparing', compareValue, value);
        return (value === compareValue) ? false : (err || true);
    }
}

function required(err){
    return value => {
        switch (typeof value) {
            case 'string':
                if (value && value.trim().length > 0) {
                    return false;
                } else {
                    return err || true;
                }
            case 'number':
            case 'boolean':
            case 'object':
                return false;
            default:
                return err || true;
        }
    }
}

function number(err, minDigits = 0, maxDigits = Infinity) {

    return value => {
        if (value === '') {
            return err;
        }

        value = Number(value);
        if (isNaN(value)) {
            return err
        }

        var length = (value + '').replace('.', '').length;
        if (length < minDigits) {
            return err;
        } else if (length > maxDigits) {
            return err;
        }

        return false;
    }
}

export default {
    email,
    required,
    number,
    equals
}



// WEBPACK FOOTER //
// ./web-app/utils/form-validators.js